<template>
    <div style="display: flex; flex-direction: column;">
        <div style="background: linear-gradient(0deg, #210F03 32.84%, #1270B0 100%); position: relative; padding: 0 12px">
            <div style="position: absolute; left: 50%; transform: translateX(-50%); z-index: 1;">
                <img style="width: 168px; opacity: 0.04;" :src="require('@/assets/img/siu.png')" alt="">
            </div>
            <div @click.stop="() => { $GlobalStore.closeLastModal() }" style="display: flex; align-items: center; gap: 4px; padding-left: 20px; padding-top: 26px; padding-bottom: 14px;">
                <img style="width: 10px;" :src="require('@/assets/img/white_back_btn.png')" alt="">
                <div style="font-size: 14px; font-weight: 500; color: #fff;">뒤로가기</div>
            </div>
            <div style="font-weight: 700; font-size: 32px; line-height: 46px; text-align: center; color: #fff; margin-top: 20px;">포지션 찾기 PRO</div>
            <div style="font-weight: 500; line-height: 24px; text-align: center; color: #fff;">프로들도 찾는 포지션 찾기</div>
            <div style="display: flex; justify-content: space-between; margin-top: 14px; margin-bottom: 16px; gap: 12px">
                <div v-if="isAvailableFindPro" @click="showFreeProPopup" style="background-color: #fff; z-index: 2; width: 177px; height: 40px; border-radius: 22.5px; line-height: 40px; font-size: 14px; font-weight: 500; text-align: center;">무료로 하기</div>
                <div v-if="!is_pass" @click="paymentPositionPro" style="position: relative; z-index: 2; height: 40px; width: 177px; border-radius: 22.5px; background-color: #fff; margin: 0 auto; line-height: 40px; text-align: center; font-size: 14px; font-weight: 500;">₩ 1,200</div>
                <div v-else @click="startPositionPro" style="position: relative; z-index: 2; height: 40px; width: 177px; border-radius: 22.5px; background-color: #fff; margin: 0 auto; line-height: 40px; text-align: center; font-size: 14px; font-weight: 500;">시작하기</div>
            </div>
        </div>
        <div style="flex: 1; overflow-y: scroll;padding-top: 10px;">
            <div class="hide_scroll" style="display: flex; overflow-x: scroll; margin-top: 20px; border-top: 1px solid #ededed; border-bottom: 1px solid #ededed; padding: 12px 20px">
                <div class="cont_wrap_box">
                    <div class="title">포지션 찾기 수</div>
                    <div class="sub_title">누적</div>
                    <div class="sub_title2">{{ position_try_count | comma }}회</div>
                </div>
                <div style="padding-left: 16px;" class="cont_wrap_box">
                    <div class="title">비용</div>
                    <div class="sub_title">₩</div>
                    <div class="sub_title2">1,200원</div>
                </div>
                <div style="padding-left: 16px;" class="cont_wrap_box">
                    <div class="title">이용 횟수</div>
                    <div class="sub_title">{{ is_pass ? '보유' : '최대' }}</div>
                    <div class="sub_title2">{{ is_pass ? available_cnt + '회' : '결제 후 1회' }}</div>
                </div>
                <div style="padding-left: 16px; border: none; padding-right: 0;" class="cont_wrap_box">
                    <div class="title">리워드</div>
                    <div style="display: flex;">
                        <div style="text-align: center; padding-right: 8px; position: relative">
                            <div style="margin-bottom: 8px;" class="sub_title">능력치 분석</div>
                            <img style="width: 18px;" :src="require('@/assets/img/reward_1.png')" alt="">
                            <div style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); width: 1px; height: 28px; background-color: #ededed;"></div>
                        </div>
                        <div style="text-align: center; padding: 0 8px; position: relative">
                            <div style="margin-bottom: 8px;" class="sub_title">피드백 / 훈련 방법</div>
                            <img style="width: 34px;" :src="require('@/assets/img/reward_2.png')" alt="">
                            <div style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); width: 1px; height: 28px; background-color: #ededed;"></div>
                        </div>
                        <div style="text-align: center; padding: 0 8px; position: relative">
                            <div style="margin-bottom: 8px;" class="sub_title">PRO 포지션 뱃지</div>
                            <div style="display: flex; gap: 4px;">
                                <img style="width: 20px;" :src="require('@/assets/img/reward_3.png')" alt="">
                                <img style="width: 20px;" :src="require('@/assets/img/reward_4.png')" alt="">
                            </div>
                            <div style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); width: 1px; height: 28px; background-color: #ededed;"></div>
                        </div>
                        <div style="text-align: center; padding: 0 8px; position: relative">
                            <div style="margin-bottom: 8px;" class="sub_title">프로필 이미지</div>
                            <img style="width: 54px;" :src="require('@/assets/img/reward_5.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div style="">
                <div style="margin-top: 32px; padding: 0 20px">
                    <div style="font-size: 20px;font-weight: 500;">포지션 찾기 PRO</div>
                    <div style="margin-top: 10px;font-size: 14px;font-weight: 500;line-height: 24px;">포지션 찾기 PRO는 약 200명의 프로 축구선수들과 전문 코치, 여러 프로 축구팀을 통해 얻은 포지션 찾기 데이터를 바탕으로 제작 되었습니다.</div>
                    <div style="margin-top: 26px; font-size: 14px;font-weight: 500;line-height: 24px;">모든 질문에 신중해지세요. 그리고 객관적인 선택을 해주세요.</div>
                </div>
                <div class="hide_scroll" style="display: flex; overflow-x: scroll; padding: 0 20px; gap: 24px; margin-top: 20px; margin-bottom: 12px;">
                    <div v-for="index in 4" :key="index">
                        <img style="width: 200px;" :src="require(`@/assets/img/position_pro_img${index}.png`)" alt="">
                    </div>
                </div>
                <div style="padding: 0 28px;">
                    <CircleText>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px">포지션 찾기 lite보다 한층 더 전문적인 피드백을 제공합니다.</div>
                    </CircleText>
                    <CircleText>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px">회원님의 축구 능력치를 분석해서 그래프로 표시합니다.</div>
                    </CircleText>
                    <CircleText>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px">축구를 하면서 벌어지는 여러 상황들 등 디테일한 질문들을 추가하여 테스터의 성향을 면밀히 파악할 수 있습니다.</div>
                    </CircleText>
                    <CircleText>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px;">포지션 찾기 특허를 출원했습니다.</div>
                    </CircleText>
                </div>
                <div style="height: 1px; width: calc(100% - 40px); background-color: #ededed; margin: 32px auto;"></div>
                <div style="">
                    <div style="font-size: 20px;font-weight: 500;line-height: 24px; padding-left: 20px;">결과의 정확도를 높이는<br>사커하우 포지션 찾기 가이드</div>
                    <swiper style="margin-top: 8px; height: 142px; padding: 0 20px;" ref="filterSwiper" :options="swiperOption" role="tablist">
                        <swiper-slide v-for="each, i in guideList" :key="i" style="width: 100%; display: flex; justify-content: center; height: 116px;">
                            <div style="padding: 8px 12px; background-color: #f5f5f5; border-radius: 12px;">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <img style="width: 20px;" :src="each.imgPath" alt="">
                                    <div style="font-weight: 500; font-size: 14px; color: var(--color-main); line-height: 24px; margin-bottom: 4px;">{{ each.title }}</div>
                                </div>
                                <div style="font-size: 14px;font-weight: 500;line-height: 24px;">{{ each.contents }}</div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination paging_text" slot="pagination" style="width:100%; font-size:12px; display:inline-block;"></div>
                    </swiper>
                </div>
                <div style="height: 1px; width: calc(100% - 40px); background-color: #ededed; margin: 32px auto; margin-top: 22px;"></div>
                <div style="padding: 0 20px; font-size: 20px; font-weight: 500; line-height: 24px; ">
                    <div>포지션 찾기 lite로 가볍게</div>
                    <img style="width: 350px; margin-top: 8px; margin-bottom: 12px;" :src="require('@/assets/img/position_lite.png')" alt="">
                    <div style="display: flex; justify-content: space-between;">
                        <div style="font-size: 12px;font-weight: 500;line-height: 20px;">누구나 어렵지 않게 축구 포지션 찾기!<br>더 가볍지만 정확한 결과를 제공합니다</div>
                        <div @click="showPositionLite" style="width: 93px; height: 36px; line-height: 36px; border-radius: 22.5px; background-color: #f5f5f5; color: var(--color-main); text-align: center; font-size: 12px; font-weight: 500;">바로 가기</div>
                    </div>
                </div>
                <div style="height: 1px; width: calc(100% - 40px); background-color: #ededed; margin: 32px auto;"></div>
                <div style="padding: 0 20px; padding-bottom: 60px;">
                    <div style="font-size: 20px;font-weight: 500;line-height: 24px;">포지션 정보</div>
                    <div style="font-size: 12px;font-weight: 500;line-height: 20px; margin-top: 4px; margin-bottom: 12px;">포지션 정보는 4-4-2 포메이션을 기반으로 제공됩니다. 전술에 따라 유동성이 있는 포지션의 명칭은 제외하며, 가장 대표적인 포지션만 적용됩니다.</div>
                    <div style="padding: 8px 16px; background-color: #f5f5f5; border-radius: 12px;">
                        <div style="margin-bottom: 8px;">
                            <div class="pos_title">공격</div>
                            <div class="pos_wrap">
                                <div class="pos_txt">중앙 공격수</div>
                                <div class="pos_main">CF</div>
                            </div>
                            <div class="pos_wrap">
                                <div class="pos_txt">세컨드 스트라이커</div>
                                <div class="pos_main">SS</div>
                            </div>
                            <div style="border: none;" class="pos_wrap">
                                <div class="pos_txt">윙 포워드</div>
                                <div class="pos_main">LWF / RWF</div>
                            </div>
                            <div style="height: 4px; background-color: #ededed; width: calc(100% + 32px); margin-left: -16px;"></div>
                        </div>
                        <div style="margin-bottom: 8px;">
                            <div class="pos_title">미드필더</div>
                            <div class="pos_wrap">
                                <div class="pos_txt">공격형 미드필더</div>
                                <div class="pos_main">AM</div>
                            </div>
                            <div class="pos_wrap">
                                <div class="pos_txt">중앙 미드필더</div>
                                <div class="pos_main">CM</div>
                            </div>
                            <div class="pos_wrap">
                                <div class="pos_txt">수비형 미드필더</div>
                                <div class="pos_main">DM</div>
                            </div>
                            <div style="border: none;" class="pos_wrap">
                                <div class="pos_txt">측면 미드필더</div>
                                <div class="pos_main">LM / RM</div>
                            </div>
                            <div style="height: 4px; background-color: #ededed; width: calc(100% + 32px); margin-left: -16px;"></div>
                        </div>
                        <div style="margin-bottom: 8px;">
                            <div class="pos_title">수비</div>
                            <div class="pos_wrap">
                                <div class="pos_txt">중앙 수비수</div>
                                <div class="pos_main">CB</div>
                            </div>
                            <div class="pos_wrap">
                                <div class="pos_txt">풀백</div>
                                <div class="pos_main">LB / RB</div>
                            </div>
                            <div style="border: none;" class="pos_wrap">
                                <div class="pos_txt">윙백</div>
                                <div class="pos_main">LWB / RWB</div>
                            </div>
                            <div style="height: 4px; background-color: #ededed; width: calc(100% + 32px); margin-left: -16px;"></div>
                        </div>
                        <div>
                            <div class="pos_title">골키퍼</div>
                            <div style="border: none; padding-bottom: 0" class="pos_wrap">
                                <div class="pos_txt">골키퍼</div>
                                <div class="pos_main">GK</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Util from "../../modules/util";
import { INNOPAY_MODE } from "../../Constants";
import ResponseCode from "../../ResponseCode";
import CircleText from '../common/CircleText';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'

export default {
    name: 'FindPositionProStart',
    components: { CircleText, swiper, swiperSlide },
    props: {
        originallyPosition: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            is_pass: false,
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 20, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
            },
            guideList: [
                { title: '축구팀에서의 "나"를 기준', contents: '테스트 속 질문의 기준은 현재 혹은 과거 운동 경험에서 느낀 본인의 운동 능력치를 기준으로 평가해주세요. 축구팀이 있다면 팀에서의 운동 능력을 기준으로 해주세요.', imgPath: require('@/assets/img/pro_guide_1.png') },
                { title: '확실한 정도에 체크', contents: '보다 정확한 포지션 찾기 결과를 제공받기 위해서는 확실한 측정치에 체크해야 합니다.', imgPath: require('@/assets/img/pro_guide_2.png') },
                { title: '축구 MBTI', contents: '운동 능력과 포지션에 대한 다양한 데이터를 기반으로 제작된 축구 포지션 찾기입니다. 축구 MBTI처럼 진행하시면 됩니다.', imgPath: require('@/assets/img/pro_guide_3.png') },
            ],
            available_cnt: 0,
            position_try_count: 0,
            isAvailableFindPro: false
        }
    },
    methods: {
        async getFreeAvailablePro() {
            const res = await this.$Axios.get('/api/position/available/cnt')

            this.isAvailableFindPro = res.data.is_free_availble
            this.checkCondition()
        },
        showFreeProPopup() {
            this.$GlobalStore.addModal('PositionProFreePopup', { transitionName: 'bottom', isModalBackTransparent: true })
        },
        async getAvailabeCnt() {
            const res = await this.$Axios.get('/api/position/available/cnt');
            if (res.data.available_cnt > 0) {
                this.is_pass = true;
                this.available_cnt = res.data.available_cnt
            }
        },
        paymentPositionPro() {
            this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '포지션 찾기 PRO', amt: 1200 });
        },
        startPositionPro() {
            this.$GlobalStore.addModal('MyPositionPro', { originallyPosition: this.originallyPosition })
        },
        showPositionLite() {
            this.$GlobalStore.addModal('FindPositionStart', { start: true, position: this.$GlobalStore.loginInfo().position })
        },
        completeAction() {
            this.$GlobalStore.closeModalAll()
            this.$GlobalStore.addModal('MyPositionPro', { originallyPosition: this.originallyPosition })
        },
        async payAction(pay_method, pay_mode, card_idx, selected_pay_methods) {
            INNOPAY_MODE;
            // const test = '1';
            // if('1' === test)
            //     pay_mode = INNOPAY_MODE.REGISTERED_CARD_PAY;

            const parameters = {};
            parameters.pay_mode = pay_mode;
            parameters.amt = 1200;
            parameters.goods_name = '포지션 프로 비용';
            parameters.memo = '';
            parameters.card_idx = card_idx;

            this.$GlobalStore.showProgress();

            await Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                return await this.$Axios.post('/api/position/pay', converted_parameters);
            }, async (converted_parameters) => {
                const res = await this.$Axios.post('/api/position/pay', converted_parameters);
                this.$GlobalStore.hideProgress()
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.$GlobalStore.addModal('CompletePay', { payMethodObj: selected_pay_methods, completeAction: this.completeAction })
                    // this.$GlobalStore.addModal('MyPositionPro', { originallyPosition: this.originallyPosition })
                    this.is_pass = true
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            });
        },
        async getPositionTryCount() {
            const res = await this.$Axios.get('/api/position/try/count');
            this.position_try_count = res.data.position_try_count;
        },
        async checkCondition() {
            const res = await this.$Axios.get('/api/position/free/check')

            const isScheduleComplete = res.data.isScheduleComplete
            const isShareComplete = res.data.isShareComplete
            const isShared = JSON.parse(localStorage.getItem('isShared'))

            if (isScheduleComplete && isShared && !isShareComplete && this.isAvailableFindPro) {
                this.$GlobalStore.setIsShowCompleteProCondition()
            }

            if (isScheduleComplete && isShareComplete) {
                localStorage.removeItem('isShared')
            }
        },
    },
    created() {
        this.getFreeAvailablePro()
        this.payAction = this.$Once(this.payAction);
        this.getAvailabeCnt();
        this.getPositionTryCount();
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

p {
    margin: 0;
}

.cont_wrap {
    margin-top: 40px;
}

.tit {
    line-height: 23px;
    font-weight: 400;
    color: #606060;
}

.sub_tit {
    margin-top: 30px;
    line-height: 23px;
    color: #606060;
}

.deco_circle {
    width: 5px;
    height: 5px;
    background-color: #606060;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
    margin-top: 5px;
}

.common_btn {
    height: 50px;
    background-color: var(--color-main);
    border-radius: 6px;
    color: #fff;
    width: calc(100% - 40px);
    margin-left: 20px;
    margin-top: 20px;
    line-height: 50px;
    text-align: center;
}

.pro_contents {
    line-height: 20px;
    color: #606060;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}

.cont_wrap_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #ededed;
    padding-right: 16px;
    white-space: nowrap;
}

.title {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: #606060;
}

.sub_title {
    font-size: 10px;
    font-weight: 500;
    line-height: 20px;
    color: #808080;
}

.sub_title2 {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}

.swiper .swiper-pagination {
    position: absolute;
    bottom: 65px !important;
}

.swiper-pagination>>>.swiper-pagination-bullet {
    background: #d9d9d9;
    width: 6px;
    height: 6px;
    opacity: 1;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: var(--color-main)
}

.pos_title {
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
    border-bottom: 1px solid #ededed;
    padding-bottom: 8px;
}

.pos_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #ededed
}

.pos_txt {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: #808080;
}

.pos_main {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}
</style>
